export default "__VITE_ASSET__98986b29__"